module.exports = __webpack_public_path__ + "static/media/story-16.543a2dfa.jpg";